import { Dialog, DialogContent, DialogTitle, Paper, Box } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

const GroupsModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleGroupClick = (group) => {
		props.onGroupSelected(group);
	};
	
	return (
		<Dialog
			open={props.groups? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="md"
		>
			<DialogTitle id="alert-dialog-title">
				User Groups
			</DialogTitle>
			<DialogContent>
				<Box sx={{width: "100%", margin: "auto"}}>
					<TableContainer component={Paper} sx={{ width: "100%" }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell sx={{ textAlign: "left" }}>Name</TableCell>
									<TableCell sx={{ textAlign: "center" }}>Employee Count</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{props.groups? props.groups.map((group) => (
									<TableRow
										key={`group_${group.id}`}
										sx={{ ":hover": { cursor: "pointer" } }}
										onClick={() => { handleGroupClick(group); }}
									>
										<TableCell sx={{ textAlign: "left" }}>
											{`${group.name}`}
										</TableCell>
										<TableCell sx={{ textAlign: "center" }}>
											{`${group.company_employees.length}`}
										</TableCell>
									</TableRow>
								)):<React.Fragment/>}
							</TableBody>
						</Table>
					</TableContainer>
				</Box>
			</DialogContent>
		</Dialog>
	);

}

export default GroupsModal;